<template>
  <div>
    <q-select
      dense
      outlined
      :model-value="props.modelValue"
      @update:model-value="(value) => $emit('update:modelValue', value)"
      :options="listaClientes"
      option-label="clienteId"
      option-value="clienteId"
      behavior="menu"
      map-options
      use-input
      @filter="filtrar"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="white">Nenhum resultado</q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script setup>
import { defineProps, ref } from "vue";
import { useStore } from "vuex";

const store = useStore();
const props = defineProps({
  modelValue: {},
});

const listaClientes = ref([]);

const listarClientes = async (val) => {
  try {
    const response = await store.dispatch("office/listarCliente");
    listaClientes.value = response.listaClientes.filter((cliente) => {
      return cliente.clienteId.toLowerCase().includes(val.toLowerCase());
    });
  } catch (error) {
    console.log(error);
  }
};

const filtrar = (val, update) => {
  listarClientes(val);
  setTimeout(() => {
    update();
  }, 500);
};
</script>
